import { ChannelType } from 'src/api/generated';
import { getInlineInputRemPadding } from 'src/modules/shared/components/atoms/buttons/button/button.styles';
import type { ComponentSize } from 'src/modules/shared/types/component.type';
import { isValidEmail } from 'src/modules/shared/utils/validation/email.util';
import { isValidPhoneNumber } from 'src/utils/validation/phone';

export const isPhoneChannel = (channelType: ChannelType) =>
  channelType === ChannelType.PHONE || channelType === ChannelType.WHATSAPP;

export const isEmailChannel = (channelType: ChannelType) =>
  channelType === ChannelType.EMAIL;

export const isValidAddressForChannel = (
  channelType: ChannelType,
  address: string
) =>
  (isPhoneChannel(channelType) && isValidPhoneNumber(address)) ||
  (isEmailChannel(channelType) && isValidEmail(address));

export const getAddressInputType = (channelType: ChannelType) => {
  switch (channelType) {
    case ChannelType.EMAIL:
      return 'email';
    case ChannelType.PHONE:
    case ChannelType.WHATSAPP:
      return 'tel';
    default:
      return 'text';
  }
};

export const getAddressInputPattern = (channelType: ChannelType) => {
  if (isPhoneChannel(channelType)) return '[0-9]*';

  return undefined;
};

export const getAddressVariant = (channelType: ChannelType) => {
  if (channelType === ChannelType.WHATSAPP) return 'whatsapp';
  if (channelType === ChannelType.PHONE) return 'call';

  return 'email';
};

export const getVariantToneClassName = ({
  variant,
  className,
}: {
  variant: 'whatsapp' | 'call' | 'email';
  className: string;
}) => {
  if (variant === 'whatsapp') {
    return `!text-whatsapp-500 ${className}`;
  }
  if (variant === 'call') {
    return `!text-call-500 ${className}`;
  }

  return `!text-email-500 ${className}`;
};

export const getAddressInputPaddings = (
  size: ComponentSize,
  hasChannelDropdown: boolean
): { leftPadding?: number; rightPadding?: number } => {
  const rightPadding = getInlineInputRemPadding(size);

  if (hasChannelDropdown) {
    const leftPadding = getInlineInputRemPadding(size);
    return { leftPadding, rightPadding };
  }

  return { rightPadding };
};
